// Track only requests that can open a wallet signature/transaction confirmation.
let pending = 0;
const idleListeners = new Set();
const trackedProviders = new WeakMap();

async function withWalletSigning(operation) {
  pending += 1;
  try {
    return await operation();
  } finally {
    pending -= 1;
    if (!pending) {
      // Let the caller process the signature or transaction hash first.
      setTimeout(() => {
        if (!pending) idleListeners.forEach(listener => listener());
      }, 0);
    }
  }
}

function trackWalletProvider(provider) {
  if (!provider || typeof provider.request !== 'function') {
    throw new Error('Wallet provider is unavailable');
  }
  if (!trackedProviders.has(provider)) {
    const tracked = new Proxy(provider, {
      get(target, property) {
        if (property === 'request') {
          return payload => {
            const send = () => target.request(payload);
            return /^(?:personal_sign|eth_sign(?:TypedData(?:_v[34])?|Transaction)?|eth_sendTransaction)$/.test(payload.method)
              ? withWalletSigning(send) : send();
          };
        }
        const value = Reflect.get(target, property, target);
        return typeof value === 'function' ? value.bind(target) : value;
      },
    });
    trackedProviders.set(provider, tracked);
  }
  return trackedProviders.get(provider);
}

function onWalletIdle(listener) {
  idleListeners.add(listener);
  return () => idleListeners.delete(listener);
}

module.exports = { withWalletSigning, trackWalletProvider, onWalletIdle,
  isWalletSigning: () => pending > 0 };
